import { useQuery } from "@apollo/client";

import { PLAYER_SEARCH } from "MVVM/GraphQL/playerSearch";
import { ESupportedGames } from "MVVM/@types";

export const useResolvedPlayerIdentifier = (
  playerGameIdentifier: string | undefined,
  game: ESupportedGames,
) => {
  const games: Partial<
    Record<ESupportedGames, { name: string; idFormat: string }>
  > = {
    [ESupportedGames.LOL]: { name: "LOL", idFormat: "puuid" },
  };

  const skip = !games[game] || !playerGameIdentifier;

  const variables = skip
    ? {}
    : {
        gameIdentifier: playerGameIdentifier,
        game: games[game]!.name,
      };

  const { data, loading, error } = useQuery(PLAYER_SEARCH, {
    variables,
    skip,
  });

  let resolvedPlayerIdentifier = playerGameIdentifier;

  if (!skip && data?.playerSearch?.success) {
    const identifierField = games[game]!.idFormat;
    if (data.playerSearch[identifierField]) {
      resolvedPlayerIdentifier = data.playerSearch[identifierField];
    }
  }

  return { resolvedPlayerIdentifier, loading, error };
};
